import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  conditionalRow: {
    backgroundColor: '#ffcccc',
    '&:hover': {
      backgroundColor: '#fcb0b1 !important'
    }
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  title: {
    display: 'flex',
    alignItems: 'center'
  },
  form: {
    display: 'flex'
  },
  input: {
    flexGrow: 1
  },
  createButtonContainer: {
    marginLeft: '16px'
  },
  containerName: {
    display: 'flex',
    gap: 4
  },
  colorTicket: {
    width: '10px',
    minWidth: '10px',
    height: '10px',
    borderRadius: '50%',
    alignSelf: 'center'
  },
  containerButtons: {
    display: 'flex',
    gap: 8,
    alignItems: 'center'
  },
  imageLayout: {
    objectFit: 'contain',
    borderRadius: 8,
    border: '1px solid #eee',
    display: 'block'
  }
}))

export default useStyles
